module.exports = __webpack_public_path__ + "img/image7.69ed1c5a.png";